import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./kioskSuccess.scss";
import { KioskBookingDetailsCard } from "./KioskBookingDetailsCard";
import { KioskHelpFooter } from "./KioskHelpFooter";
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons";
import { IBooking } from "redux/reducers/models/teetime";
import { ICustomer } from "redux/reducers/models/customer";
import { ButtonNew as Button } from "components/buttonNew";

interface IKioskSuccessProps {
  onDone: () => void;
  booking: IBooking | null;
  customer: Partial<ICustomer> | null;
  searchType: string;
}

export function KioskSuccess({ onDone, booking, customer, searchType }: IKioskSuccessProps) {
  const { t } = useTranslation();

  // Auto-reset timer: Reset kiosk to home page after 15 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onDone();
    }, 15000);

    // Cleanup timer if component unmounts
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <div className="ui-kiosk-container">
      <div className="ui-kiosk-icon-success-container">
        <FontAwesomeIcon icon={faCircleCheck} className="ui-kiosk-icon-success" />
      </div>

      <p className="ui-kiosk-title">{t("Check-in complete")}</p>
      <p className="ui-kiosk-subtitle">{t("You're all set! Please proceed to the first tee.")}</p>

      <KioskBookingDetailsCard booking={booking} customer={customer} searchType={searchType} />

      <div className="ui-kiosk-button-container ui-kiosk-payment-buttons">
        <Button onClick={onDone} type="secondary" className="ui-kiosk-button">
          {t("Return to home")}
        </Button>
      </div>

      <KioskHelpFooter />
    </div>
  );
}
